import React from "react";
import "./TopHeader.scss";
import plane from "../../../images/Rectangle_7.png";
import faa from "../../../images/faa_logo.png";
import pfsLogo from "../../../images/pfs-logo.png";
import natcaLogo from "../../../images/natca_logo.png";
import { Image } from "@aws-amplify/ui-react";
import { UI_STRINGS } from "../../../constants/ui-strings.ts";

export interface TopHeaderProps {
  user: any;
}

export const TopHeader = (props: TopHeaderProps) => {
  const { user } = props;

  return (
    <div className="top-header">
      <div className="logos">
        <Image src={plane} alt={UI_STRINGS.HEADER.PLANE_ALT} className="small" />
        <h1>{UI_STRINGS.HEADER.TITLE}</h1>
        <Image src={faa} alt={UI_STRINGS.HEADER.PLANE_ALT} />
        <Image src={pfsLogo} alt={UI_STRINGS.HEADER.PLANE_ALT} className="medium" />
        <Image src={natcaLogo} alt={UI_STRINGS.HEADER.PLANE_ALT} />
      </div>

      <Image className="gravatar" src={user.picture} alt={UI_STRINGS.HEADER.GRAVATAR_ALT} />
    </div>
  );
};
